//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.ConditionsBuilder.js";
import "../AME/AME.ObjectConnectionDetailBuilder.js";
import "../AME/AME.SelectIPort.js";
import "../no/SelectObject.js";
let d=[[[1,"Conditions",0,"AME.ConditionsBuilder",0],[0,"Negation",1,0],[1,"ObjectConnectionDetail",0,"AME.ObjectConnectionDetailBuilder",0],[0,"OperatorType",1,0],[0,"ParameterRuleType",1,0],[1,"Port",0,"AME.SelectIPort",0],[0,"RuleName",1,0]],[[["parameterType","atIndex"],"CreateParameter",{R_:{ruleParam:"NXObject"}},2,0],[["parameterType","index"],"UpdateParameter",{R_:{ruleParam:"NXObject"}},2,0],[["parameterType","index"],"DeleteParameter",{},2,0],[["parameterType","moveFromIndex","moveToIndex"],"MoveParameter",{},3,0]],[]];
SPLM.AME.OperatorRuleBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.OperatorRuleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.OperatorRuleBuilder.NegationValue = Object.freeze({
    "False" : "False", "True" : "True"});

SPLM.AME.OperatorRuleBuilder.ParameterType = Object.freeze({
    "Input" : "Input", "Output" : "Output"});

export default SPLM;